import React from 'react';
import { Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import { formatSlot, groupByDay, isoToday } from '../../constants/openingHours';

/**
 * A shop's week as a table, one row per day, with today's row picked out so a
 * resident standing outside can see at a glance whether it is open.
 *
 * `today` is a prop only so a test can pin the day.
 */
function OpeningHoursTable({ hours, today = isoToday() }) {
  return (
    <Table size="small" aria-label="Horaires d’ouverture" sx={{ width: 'auto' }}>
      <TableBody>
        {groupByDay(hours).map(({ day, label, slots }) => {
          const isToday = day === today;

          return (
            <TableRow
              key={day}
              aria-current={isToday ? 'date' : undefined}
              sx={{
                bgcolor: isToday ? 'action.selected' : undefined,
                '& td, & th': { border: 0, py: 0.5, px: 1.5, fontWeight: isToday ? 700 : 400 },
              }}
            >
              <TableCell component="th" scope="row">
                {label}
              </TableCell>
              <TableCell>
                {slots.length > 0 ? (
                  slots.map((slot) => (
                    <Typography key={slot.opens} variant="body2" component="div" sx={{ fontWeight: 'inherit' }}>
                      {formatSlot(slot)}
                    </Typography>
                  ))
                ) : (
                  <Typography variant="body2" component="span" color="text.secondary" sx={{ fontWeight: 'inherit' }}>
                    Fermé
                  </Typography>
                )}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}

export default OpeningHoursTable;
